export default ({ request }) => ({
  customerApprovalRequsetListApi(data) {
    return request({
      url: '/digitalCenter/customer/approval/requset/list',
      method: 'post',
      data,
    })
  },
  customerApprovalRequsetDetailApi(data) {
    return request({
      url: '/digitalCenter/customer/approval/requset/detail',
      method: 'post',
      data,
    })
  },
  customerApprovalRequsetApprovalApi(data) {
    return request({
      url: '/digitalCenter/customer/approval/requset/approval',
      method: 'post',
      data,
    })
  },
  customerApprovalRequsetRejectApi(data) {
    return request({
      url: '/digitalCenter/customer/approval/requset/reject',
      method: 'post',
      data,
    })
  },
})
